import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface TransitionVideoProps {
    destinationPath: string;  // Removed onVideoEnd prop since it's not used
}

const TransitionVideo: React.FC<TransitionVideoProps> = ({ destinationPath }) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const audioRef = useRef<HTMLAudioElement>(null);
    const [isExiting, setIsExiting] = useState(false);
    const navigate = useNavigate();
    const [showSkip, setShowSkip] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSkip(true);
        }, 1000);

        // Capture current audio element
        const audio = audioRef.current;

        if (audio) {
            audio.play().catch(error => {
                console.log('Audio autoplay failed:', error);
            });
        }

        return () => {
            clearTimeout(timer);
            if (audio) {
                audio.pause();
                audio.currentTime = 0; // Reset audio to beginning
            }
        };
    }, []);

    const handleSkip = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0; // Reset audio to beginning
        }
        navigate(destinationPath);
    };

    const handleVideoEnd = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0; // Reset audio to beginning
        }
        setIsExiting(true);
        setTimeout(() => {
            navigate(destinationPath);
        }, 1000); // Match transition duration
    };

    return (
        <div
            className={`
                relative w-screen h-screen
                transition-opacity duration-1000
                ${isExiting ? 'opacity-0' : 'opacity-100'}
            `}
        >
            <video
                ref={videoRef}
                className="w-full h-full object-cover"
                autoPlay
                muted
                onEnded={handleVideoEnd}

            >
                <source src="/videos/herculesGrowingUp.mp4" type="video/mp4" />
            </video>

            <audio ref={audioRef} src="/audio/Apollon-audio.mp3" />

            {showSkip && (
                <button
                    onClick={handleSkip}
                    className="absolute bottom-8 right-8 px-6 py-3 bg-terracotta text-warm-cream 
                             rounded-lg shadow-lg font-cinzel hover:bg-terracotta/80 
                             transition-all duration-300"
                >
                    Skip
                </button>
            )}
        </div>
    );
};

export default TransitionVideo;
